import { z } from 'zod';
import { authConfigSchema } from '../auth/authConfig';

/** The shape of the web app's runtime `/config.json` (QZ-D10). */
export const webConfigSchema = z
  .object({
    apiUrl: z.url({ protocol: /^https?$/ }),
    auth: authConfigSchema,
  })
  .strip();
export type WebConfig = z.infer<typeof webConfigSchema>;
